<template>
    <!-- Load Mobile -->
    <template v-for="game in [1, 2, 3, 4]">
        <template v-for="item in [1, 2, 3, 4, 5]">
            <div class="relative animate-pulse sm:w-full min-w-[105px] overflow-hidden cursor-pointer">
                <div
                    class="h-[160px] animate-pulse rounded-xl sm:h-[177px] sm:w-[144px] lg:h-[189px] lg:w-[162px] xl:h-[241px] xl:w-[197px] w-full bg-secondary flex items-center justify-between gap-10 ">
                </div>
            </div>
        </template>
    </template>
</template>